import { getStudentListAttendance, postAttendance, updateAttendance, deleteAttendance, getAttendanceListByStudent, postAttendanceMore } from "@/services/attendance.service";

import Vue from "vue";

// import { formatDateToHour } from "@/utils/utils";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Oturum açan kullanıcının yoklama bilgisi
  async loadAttendanceListByStudent() {
    return await getAttendanceListByStudent().then((response) => {
      let data = response.data.data;

      data.map((d, index) => {
        d.index = index + 1;

        d.rollCallId = d?.attendance?.rollCallId == 1 ? false : d?.attendance?.rollCallId == 2 ? true : null;

        let startTime = d.lookingDate.split("T")[0] + "T" + d.startDate.split("T")[1];
        let endTime = d.lookingDate.split("T")[0] + "T" + d.endDate.split("T")[1];

        Vue.set(d, "startTime", startTime);
        Vue.set(d, "endTime", endTime);
      });

      return data;
    });
  },

  //Yoklama Öğrenci Listesi
  async loadStudentListAttendance(vuexContext, co) {
    return await getStudentListAttendance(
      // vuexContext.rootState.pagination.co
      co
    ).then((response) => {
      let data = response.data.data;

      data.map((student, index) => {
        student.index = index + 1;
        student.classDayAndTimeAndAttendanceStudentDto.map((attendance) => {
          if (attendance.rolCallId == 2) {
            student[attendance.id] = true;
          } else if (attendance.rolCallId == 1) {
            student[attendance.id] = false;
          } else {
            attendance.rolCallId = null;
          }
        });

        student.classDayAndTimeAndAttendanceStudentDto.sort((a, b) => {
          return new Date(b.startDate) - new Date(a.startDate);
        });
      });
      // data.sort((a, b) => {
      //   return new Date(b.startDate) - new Date(a.startDate);
      // });

      // vuexContext.commit("setStudentList", items);
      return data;
    });
  },

  async postAttendance(vuexContext, data) {
    await postAttendance(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async postAttendanceMore(vuexContext, data) {
    await postAttendanceMore(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateAttendance(vuexContext, data) {
    await updateAttendance(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteAttendance(vuexContext, data) {
    await deleteAttendance(data).then((response) => {
      let data = response;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
